import React from 'react';
import { Sparkles } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="sticky top-0 z-50 w-full bg-danger text-white py-2 px-4 text-center text-xs md:text-sm font-bold tracking-wide shadow-md overflow-hidden relative" data-id="element-19">
      {/* Animated stripe pattern */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.15) 0, rgba(255,255,255,0.15) 8px, transparent 8px, transparent 16px)'
    }} data-id="element-20" />
      <div className="relative flex items-center justify-center gap-2" data-id="element-21">
        <Sparkles size={14} className="animate-pulse" data-id="element-22" />
        <span data-id="element-23">
          🔥 OFERTA DE LANZAMIENTO — Acceso inmediato + Garantía 7 días
        </span>
        <Sparkles size={14} className="animate-pulse" data-id="element-24" />
      </div>
    </div>;
}